export default "__VITE_ASSET__61VfZtol__"